import React, { createContext, PropsWithChildren, useContext } from 'react';

interface TargetedStoryAIOptOutValue {
  summariesOptOut: boolean;
  prototypesOptOut: boolean;
  chatOptOut: boolean;
}

const TargetedStoryAIOptOutContext = createContext<TargetedStoryAIOptOutValue>({
  summariesOptOut: false,
  prototypesOptOut: false,
  chatOptOut: false,
});

interface TargetedStoryAIOptOutProviderProps extends PropsWithChildren {
  summariesOptOut?: boolean;
  prototypesOptOut?: boolean;
  chatOptOut?: boolean;
}

export function TargetedStoryAIOptOutProvider({
  children,
  summariesOptOut = false,
  prototypesOptOut = false,
  chatOptOut = false,
}: TargetedStoryAIOptOutProviderProps) {
  return (
    <TargetedStoryAIOptOutContext.Provider
      value={{ summariesOptOut, prototypesOptOut, chatOptOut }}
    >
      {children}
    </TargetedStoryAIOptOutContext.Provider>
  );
}

/**
 * Hook that is meant to be used in conjunction with TargetedStoryAIOptOutProvider. This will
 * allow individual/targeted features to opt out of story-ai variants of components.
 *
 * @returns Values from any specifically targeted features opting out of story-ai
 */
export const useTargetedStoryAIOptOutContext = () => {
  const { summariesOptOut, prototypesOptOut, chatOptOut } = useContext(
    TargetedStoryAIOptOutContext,
  );
  return { summariesOptOut, prototypesOptOut, chatOptOut };
};
